import Header from '../components/Header';
import Services from '../components/Services';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';

const ServicesPage = () => {
  return (
    <>
      <Header />
      <div style={{paddingTop: '64px'}} className="svc-light">
        <Services />
      </div>
      <Footer />
      <WhatsAppFloat />
    </>
  );
};

export default ServicesPage;
